import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "TextImage" }
const _hoisted_2 = { class: "TextImage__Inner section__inner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "TextImage__Background color--1" }, null, -1)
const _hoisted_4 = { class: "TextImage__Subinner section__subinner" }
const _hoisted_5 = { class: "section-title color--2" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyPicture = _resolveComponent("LazyPicture")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_LazyPicture, {
          class: "picture picture--appear",
          image: _ctx.slide.image,
          alt: _ctx.slide.title
        }, null, 8, ["image", "alt"]),
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.slide.title), 1),
          _createElementVNode("div", {
            class: "section-text color--4",
            innerHTML: _ctx.paragraph(_ctx.slide.text)
          }, null, 8, _hoisted_6)
        ])
      ])
    ])
  ]))
}